import React from 'react';
import ServiceItem from './service-item.jsx';

const ServiceContainer = ({letter, services }) => (
  <div key={letter} className="letter--detail">
    <h2 id={letter}  className="letter--detail--title heading heading__large">{letter}</h2>
    <ul className="letter--detail--services list__presentational">
      {
        services.map(service => {
          return(
            <ServiceItem key={service.title} title={service.title} url={service.url} />
          )
        })
      }
    </ul>
    <a href="#browse--services" className="letter--detail--back">Back to top</a>
  </div>
);

export default ServiceContainer;
